import type { JobAdsLikedStateRequest } from "./types"

import { handleResponseNotOk } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

export const setJobAdLikedState = async (params: JobAdsLikedStateRequest): Promise<void> => {
  const { id, like, hostname } = params

  const path = `/api/dashboard/v1/job_ads/${id}/${like ? "save" : "unsave"}`

  return fetcher(path, {
    hostname,
    requestInit: {
      body: JSON.stringify({ post_id: id }),
      method: "POST",
    },
    serviceDomain: "MONOLITH_API",
  })
    .then(handleResponseNotOk)
    .catch(handleFetchError(path, params))
}
